import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ExceptionManager } from "Core/logManager";
import { clientQuery, clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";
import {clientGET} from 'Core/data/RestApi';

const INIT_STATE = {
  loading: false,
  csvFile: null,
  urlFileCsv: null,
  file: null,
  transactionError: false,
  transactions: [],
};

const route = "modules/realtimeMaps/main/landmark/components/landmarkImport/redux/slice";


export const loadFileCsvLandmark = createAsyncThunk(
  `${route}/loadFileCsvLandmark`, // cambiar estas rutas
  async (payload, { rejectWithValue }) => {
    const { Url } = payload;

    try {
      const result = await clientGET('', {}, Url, false);
      if (result) {
        return { error: false, file: result };
      } else {
        throw "Error while loading CSV file";
      }
    } catch (exc) {
      ExceptionManager(
        exc,
        route,
        "loadFileCsvLandmark",
        true
      );
      return rejectWithValue({ error: true, file: null });
    }
  }
);

export const getUrlFileAttachmentLandmark = createAsyncThunk(
  `${route}/getUrlFileAttachmentLandmark`, 
  async (payload, { rejectWithValue }) => {
    const { id } = payload;
    
    try {
      const data = await clientQuery(
        `query (
          $id: Int!
        ){
          downloadAttachmentUrl: downloadAttachmentUrl(
            id: $id
          )
        }`,
        {
          id
        },
        endpoints.GRAPHQL_GENERAL,
      );

      if (data && data.downloadAttachmentUrl && data.downloadAttachmentUrl) {
        return data.downloadAttachmentUrl;
      } else {
        throw 'There are not url attachment';
      }
    } catch (exc) {
      ExceptionManager(
        exc,
        route, 
        'getUrlFileAttachmentLandmark',
      );
      return rejectWithValue(null);
    }
  }
);

export const searchLandmarkTransaction = createAsyncThunk(
  `${route}/searchLandmarkTransaction`,
  async (payload, { rejectWithValue }) => {
    const {
      transactionId,
      nextToken
    } = payload;

    try {
      const query = `
        query searchTransactions ($transactionId: String!, $nextToken: String) {
          searchTransactions (transactionId: $transactionId, nextToken: $nextToken) {
            items {
              Id
              TransactionId
              Type
              State
              ErrorMessage
              NewId
              Data
              CreatedBy
              CreatedOn
              ProcessedOn
            }
            nextToken
          }
        }
      `;

      const response = await clientQuery(
        query,
        {
          transactionId,
          nextToken
        },
        endpoints.GRAPHQL_GENERAL
      );

      if (!response || !response.searchTransactions) {
        throw "Error while getting Transactions";
      }

      return { items: response.searchTransactions, error: false };
    } catch (exc) {
      ExceptionManager(
        exc,
        route,
        "searchLandmarkTransaction"
      );
      return rejectWithValue({ items: [], error: true });
    }
  }
);

export const LandmarkImportSliceReduxSlice = createSlice({
  name: route,
  initialState: INIT_STATE,
  reducers: {
    resetLandmarkImportState: (state, action) => {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    }
  },
  extraReducers: (builder) => {

    //loadFileCsvLandmark
    builder.addCase(loadFileCsvLandmark.pending, (state, action) => {
        state.loading = true;
    });
    builder.addCase(loadFileCsvLandmark.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.csvFile = payload.file;
        state.csvFileError = payload.error;
    });
    builder.addCase(loadFileCsvLandmark.rejected, (state, { payload }) => {
        state.loading = false;
        state.csvFile = payload?.file || null;
        state.csvFileError = payload?.error || true;
    });

    //getUrlFileAttachment
    builder.addCase(getUrlFileAttachmentLandmark.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getUrlFileAttachmentLandmark.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.urlFileCsv = payload;
    });
    builder.addCase(getUrlFileAttachmentLandmark.rejected, (state, { payload }) => {
      state.loading = false;
      state.urlFileCsv = payload;
    });

    builder.addCase(searchLandmarkTransaction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(searchLandmarkTransaction.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.transactions = payload.items;
      state.transactionError = payload.error;
    });
    builder.addCase(searchLandmarkTransaction.rejected, (state, { payload }) => {
      state.loading = false;
      state.transactions = [];
      state.transactionError = true;
    });

  },
});

// Name Redux Slice: landmarkImportSliceRedux
const { actions, reducer } = LandmarkImportSliceReduxSlice;

export const { resetLandmarkImportState } = actions;

export default reducer;